(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.directive('talking', ['CallsService', TalkingDirectiveFn]);

    /* talking directive */
    function TalkingDirectiveFn(CallsService) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/ringfoon/templates/talking.template.html'
        };
        return directive;

        function link(scope) {
            // call data
            scope.call = CallsService.call;
            
            // end call
            scope.hangUp = function () {
                CallsService.decline();
            };

        } // link
    }
})();